import DNOServiceClient from '../common/clients/DNOServiceClient';
import { LN_ACCURACY_FETCH_RETRY } from '../common/api/apiRetryGetConstants';
import { LN, ACCURACY } from '../constants/measure';
import selectors from '../rootSelectors';

export const SET_LN_CONTENT = 'SET_LN_CONTENT';

export const setLNContent = (content) => ({
    type: SET_LN_CONTENT,
    content,
});

export const fetchLNContent = () => (dispatch, getState) => {
    const state = getState();
    const grade = selectors.getGrade(state);
    const period = selectors.getToy(state);

    return dispatch(DNOServiceClient.getForm(
        LN.ASSESSMENT,
        ACCURACY,
        grade,
        period,
        LN_ACCURACY_FETCH_RETRY,
    )).then((contentJson) => {
        if (contentJson instanceof Array) {
            const content = contentJson.length > 0
                ? contentJson[0]
                : contentJson;
            dispatch(setLNContent(content));
        }
    });
};
